import React from 'react'
import ConfigurationWrapper from '../3modules/Config/ConfigurationWrapper'
import useConfiguration from '../../services/configPage/useConfiguration'
import useFieldsConfiguration from '../../services/configPage/useFieldsConfiguration'
import FieldsTable from '../3modules/Layouts/FieldsTable'

//Arbitrary change to trigger a rebuild
const FieldsConfiguration = () => {
  const {
    onEditMode,
    setOnEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    isLoading,
    setIsLoading,
  } = useConfiguration()

  const {
    fields,
    handleCreateField,
    handleEditField,
    handleSuspendField,
    handleDeleteField,
  } = useFieldsConfiguration(setIsLoading, setIsSnackbarOpen)

  return (
    <ConfigurationWrapper
      header={'Fields Configuration'}
      onEditMode={onEditMode}
      setOnEditMode={setOnEditMode}
      handleCancel={() => {}}
      isSnackbarOpen={isSnackbarOpen}
      setIsSnackbarOpen={setIsSnackbarOpen}
      isLoading={isLoading}
      handleSave={() => {}}
      showEditButtons={false}
    >
      <FieldsTable
        onEditMode={onEditMode}
        fields={fields}
        onCreateField={handleCreateField}
        onEditField={handleEditField}
        onSuspendField={handleSuspendField}
        onDeleteField={handleDeleteField}
      />
    </ConfigurationWrapper>
  )
}

export default FieldsConfiguration
